import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "@material-ui/core";
import qs from "query-string";

import { validateThenLogin } from "../../actions/auth";
import "./LoginModal.scss";

class LoginModal extends React.Component {
  state = {
    name: "",
    email: "",
    password: ""
  };

  localLogin = async () => {
    const { name, email, password } = this.state;

    // validate fields
    if (
      email === "" ||
      password === "" ||
      (name === "" && !this.props.loginModal)
    ) {
      return this.setState({ loginErr: "One of the above fields is empty" });
    } else if (this.props.auth.error) {
      console.log(this.props.auth.error);
      return this.setState({ loginErr: "Server error" });
    }

    // try login
    const res = await fetch(
      `${this.props.auth.API_ENDPOINT}/auth/local${
        this.props.loginModal ? "" : "/create"
      }?${qs.stringify({
        name,
        email,
        password
      })}`,
      { credentials: "include" }
    )
      .then(resp => {
        if (resp.ok) return resp.json();
        else console.log("error logging in");
      })
      .catch(err => console.log(err));

    if (res && res.status >= 400) {
      this.setState({ loginErr: res.message });
    } else {
      // update redux
      this.props.validateThenLogin(res.token);
    }
  };

  googleLogin = () => {
    const link = `${this.props.auth.API_ENDPOINT}/auth/google`;
    window.location.href = link;
  };

  onInputChange = (field, value) => {
    const newState = { [field]: value };
    if (this.state.loginErr && value !== "") newState.loginErr = undefined;

    this.setState(newState);
  };

  render() {
    return (
      <Modal
        id="loginModal"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <div className="modalContainer">
          <button className="closeButton" onClick={this.props.onClose}>
            X
          </button>
          <div style={{ padding: "1.33em 20px" }}>
            <h3>
              {this.props.loginModal ? "Log in to" : "Sign up for"} SafeBox with
            </h3>

            <div style={{ textAlign: "center" }}>
              <div className="loginButtons">
                <button
                  className="googleSignIn"
                  onClick={this.googleLogin}
                  style={{ marginRight: 0 }}
                >
                  <img
                    src={require("../../assets/logo/companies/google.png")}
                    alt="google logo"
                  />
                  Google
                </button>
                {/* <button className="facebookSignIn">
                  <img
                    src={require("../../assets/logo/companies/facebook.png")}
                    alt="facebook logo"
                  />
                  Facebook
                </button> */}
              </div>
              <div className="orDivider">
                <div style={{ marginRight: 7 }} />
                or
                <div style={{ marginLeft: 7 }} />
              </div>
              <form onSubmit={e => e.preventDefault()}>
                {!this.props.loginModal && (
                  <input
                    type="text"
                    placeholder="Name"
                    value={this.state.name}
                    onChange={event =>
                      this.onInputChange("name", event.target.value)
                    }
                  />
                )}
                <input
                  type="email"
                  placeholder="Email"
                  autoComplete={this.props.loginModal ? "username email" : ""}
                  value={this.state.email}
                  onChange={event =>
                    this.onInputChange("email", event.target.value)
                  }
                />
                <input
                  type="password"
                  placeholder="Password"
                  autoComplete={this.props.loginModal ? "password" : ""}
                  value={this.state.password}
                  onChange={event =>
                    this.onInputChange("password", event.target.value)
                  }
                />
                <button className="submitButton" onClick={this.localLogin}>
                  {this.props.loginModal ? "Log in" : "Sign up"}
                </button>
                {this.state.loginErr && (
                  <p style={{ textAlign: "center", color: "red", margin: 0 }}>
                    {this.state.loginErr}
                  </p>
                )}
              </form>
            </div>

            {this.props.loginModal ? (
              <p>
                Not a member?
                <button onClick={this.props.onSignUpClick}>Sign up</button>
              </p>
            ) : (
              <p>
                Already have an account?
                <button onClick={this.props.onLoginClick}>Log in</button>
              </p>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

LoginModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  loginModal: PropTypes.bool,
  onSignUpClick: PropTypes.func,
  onLoginClick: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  validateThenLogin: token => dispatch(validateThenLogin(token))
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModal);
